import { ActivityEntry, ActivityEntryByDate, ActivityEntryType } from '@algoan/dashboard/model';

const convertInDateTimeFormat = (date: string): string => new Intl.DateTimeFormat('en-US').format(new Date(date));

const getActivityEntryDate = (activityInformation: ActivityEntry): string | undefined =>
  activityInformation.type === ActivityEntryType.FOLDER_SHARE
    ? activityInformation?.partnerData?.[0].createdAt
    : activityInformation.recategorisationData?.[0].createdAt;

export const sortActivityEntryList = (activityEntryList: ActivityEntry[]): ActivityEntryByDate[] => {
  const activityEntryListGroupedByDate: ActivityEntryByDate[] = [];

  activityEntryList.forEach((activityInformation: ActivityEntry) => {
    if (activityInformation.type === ActivityEntryType.FOLDER_SHARE && activityInformation.partnerData) {
      activityInformation.partnerData.sort(
        (partnerDataA, partnerDataB) =>
          new Date(partnerDataA.createdAt).getTime() - new Date(partnerDataB.createdAt).getTime(),
      );
      return;
    }
    if (activityInformation.recategorisationData) {
      activityInformation.recategorisationData.sort(
        (recategorisationDataB, recategorisationDataA) =>
          new Date(recategorisationDataA.createdAt).getTime() - new Date(recategorisationDataB.createdAt).getTime(),
      );
    }
  });

  activityEntryList.sort((activityInformationA: ActivityEntry, activityInformationB: ActivityEntry) => {
    const dateA = getActivityEntryDate(activityInformationA);
    const dateB = getActivityEntryDate(activityInformationB);

    if (dateA === undefined) {
      return 1;
    }

    if (dateB === undefined) {
      return -1;
    }

    return new Date(dateB).getTime() - new Date(dateA).getTime();
  });

  activityEntryList.forEach((activityInformation: ActivityEntry) => {
    const index = activityEntryListGroupedByDate.findIndex(
      (element) => element.date === convertInDateTimeFormat(activityInformation.createdAt),
    );

    if (activityEntryListGroupedByDate.length === 0 || index === -1) {
      activityEntryListGroupedByDate.push({
        date: convertInDateTimeFormat(activityInformation.createdAt),
        activity: [activityInformation],
      });
    } else {
      activityEntryListGroupedByDate[index].activity.push(activityInformation);
    }
  });

  return activityEntryListGroupedByDate;
};
